
import * as FileSaver from 'file-saver';

export default class SummaryController {

	constructor (
		User,
		Email,
		stores,
		selectedStore,
		endDate,
		startDate,
		summary
	) {
		this.Email = Email;
		this.stores = stores;
		this.selectedStore = selectedStore;
		this.endDate = endDate;
		this.startDate = startDate;
		this.graphs = summary.graphs;
		this.showDownloadSection = !User.isWorker();
	}

	downloadBouncedEmailsList() {
		this.Email.getBounced({
			startDate: this.startDate,
			endDate: this.endDate,
		})
		.then(data => {
			fetch('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;base64,' + data.file)
				.then(res => res.blob())
				.then(blob => FileSaver.saveAs(blob, `email_eronnees_${this.startDate}_${this.endDate}.xlsx`));
		});
	}

	downloadOptouts() {
		this.Email.getOptOuts({
			startDate: this.startDate,
			endDate: this.endDate,
		})
		.then(data => {
			fetch('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;base64,' + data.file)
				.then(res => res.blob())
				.then(blob => FileSaver.saveAs(blob, `optouts_${this.startDate}_${this.endDate}.xlsx`));
		});
	}

}

SummaryController.$inject = [
	'User',
	'Email',
	'stores',
	'selectedStore',
	'endDate',
	'startDate',
	'summary'
];



// WEBPACK FOOTER //
// ./src/page/summary/summary.controller.js